import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  const _component_ChannelIcon = _resolveComponent("ChannelIcon");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["custom-select", {
      'is-open': $data.isOpen
    }]),
    style: _normalizeStyle({
      width: $props.width
    })
  }, [_createElementVNode("div", {
    class: "custom-select-trigger",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.toggleDropdown && $options.toggleDropdown(...args))
  }, [_createElementVNode("span", {
    class: _normalizeClass(["custom-select-value", {
      'is-placeholder': !$props.modelValue
    }])
  }, _toDisplayString($options.displayLabel), 3), _createVNode(_component_font_awesome_icon, {
    icon: "chevron-down",
    class: "custom-select-arrow"
  })]), _createVNode(_Transition, {
    name: "dropdown-fade"
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", {
      class: "custom-select-dropdown",
      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, option => {
      return _openBlock(), _createElementBlock("div", {
        key: option.value,
        class: _normalizeClass(["custom-select-option", {
          'is-selected': $props.modelValue === option.value
        }]),
        onClick: $event => $options.selectOption(option.value)
      }, [_renderSlot(_ctx.$slots, "option", {
        option: option
      }, () => [option.channelType ? (_openBlock(), _createBlock(_component_ChannelIcon, {
        key: 0,
        type: option.channelType,
        class: _normalizeClass(['option-icon', option.iconClass])
      }, null, 8, ["type", "class"])) : option.icon ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
        key: 1,
        icon: option.icon,
        class: _normalizeClass(['option-icon', option.iconClass])
      }, null, 8, ["icon", "class"])) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(option.label), 1)], true)], 10, _hoisted_1);
    }), 128))], 512), [[_vShow, $data.isOpen]])]),
    _: 3
  })], 6);
}